document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.knowsec .knsubcat .trft a').forEach(function (a) {
      a.setAttribute('href', 'javascript:void(0)');
    });

    document.querySelectorAll('.knowsec .knsubcat .trft a').forEach(function (a) {
      a.addEventListener('click', function () {
        document.querySelector('.knowsec').classList.toggle('optabs');
      });
    });

    document.querySelectorAll('.kncates .kncat').forEach(function (el) {
      el.addEventListener('click', function () {
        var headerHeight = 100;
        if (window.innerWidth <= 768) {
          var target = document.querySelector('.knowsec .kncondata');
          if (target) {
            var top = target.getBoundingClientRect().top + window.scrollY - headerHeight;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        }
      });
    });

});
